<template>
  <div class>
    <button class="btn_blue" @click.prevent="show">
      Kopiera
    </button>
    <modal name="modal-clone" :adaptive="true" height="auto" :scrollable="true" :width="450" @opened="opened">
      <div class="px-5 py-5">
        <h2 class="mb-4 text-xl tracking-wide">KOPIERA KLIENT</h2>

        <ValidationObserver ref="form" v-slot="{ invalid }">
          <form @submit.prevent="onCreate()">
            <ValidationProvider v-slot="{ errors }" name="Klient-Id" rules="required">
              <span class="text-gray-700">Klient-Id</span>
              <input v-model="cloneclient.clientId" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Klientnamn" rules="required">
              <span class="text-gray-700">Klientnamn</span>
              <input v-model="cloneclient.clientName" type="text" class="w-full mt-1 form-input" :class="{
                  'border-red-600 focus:border-red-600': errors[0]
                }" />
              <span class="block mt-1 text-sm text-red-500">{{
                errors[0]
              }}</span>
            </ValidationProvider>

            <div class="flex justify-end mt-10 mb-1">
              <button type="submit" class="block btn_blue" :class="{ 'opacity-50': invalid }" :disabled="invalid">Spara</button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      cloneclient: {
        clientIdOriginal: "",
        clientId: "",
        clientName: ""
      }
    };
  },
  computed: {
    ...mapGetters("clientsStore", ["current"])
  },
  methods: {
    ...mapActions("clientsStore", ["clone"]),
    show() {
      this.$modal.show("modal-clone");
    },
    opened() {
      // this.cart.description = "";
      // this.$refs.description.focus();
    },
    async onCreate() {
      this.cloneclient.clientIdOriginal = this.current.clientId;
      await this.clone(this.cloneclient);
      this.$modal.hide("modal-clone");
    }
  }
};
</script>
